import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "seatbelt"
const SeatbeltIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.5 10.462c-3.176 0-5.16-3.526-3.573-6.347a4.074 4.074 0 0 1 7.145 0c.362.644.552 1.373.552 2.116-.002 2.335-1.848 4.228-4.124 4.23m6.749 10H7.734l11.26-10.193a.77.77 0 0 0 .255-.603c-.02-.591-.656-.94-1.146-.627a1 1 0 0 0-.1.076l-2.3 2.082c-4.515-2.189-9.815.674-10.61 5.73a1 1 0 0 0-.008.107L5 21.214a.76.76 0 0 0 .75.786H19.25c.577 0 .938-.641.65-1.154a.75.75 0 0 0-.65-.384m-1.114-7.02a.74.74 0 0 0-.586.187l-5.85 5.294h7.55a.76.76 0 0 0 .75-.77 7.8 7.8 0 0 0-1.338-4.386.75.75 0 0 0-.526-.325" />
        </svg>
      }
    </span>
  )
}
export default SeatbeltIcon
